import React from "react";
import { render } from "react-snapshot";
import App from "./components/App";

render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js